// source-git-dir-resolver.ts
//
// Phase 06g R1a (debate B5): the mission worktree's `.git` is a file pointing
// at `<source repo>/.git/worktrees/<id>`; the deny rule for the source repo's
// real git dir therefore needs that directory's absolute realpath at the time
// settings are written (init, and the L6 drift re-apply). One I/O helper so
// both writers resolve it the same way.
import { promises as fs } from "node:fs";
import { isAbsolute, resolve } from "node:path";
import { defaultRunner, type GitRunner } from "./mission-initializer-worktree.js";

/** `realpath(git rev-parse --git-common-dir)` evaluated from inside the worktree. */
export async function resolveSourceGitDir(
  worktreePath: string,
  runner: GitRunner = defaultRunner,
): Promise<string> {
  const res = await runner(["rev-parse", "--git-common-dir"], worktreePath);
  if (res.status !== 0) {
    throw new Error(
      `source-git-dir-resolver: git rev-parse --git-common-dir thất bại trong ${worktreePath}: ${res.stderr.trim()}`,
    );
  }
  const raw = res.stdout.trim();
  const abs = isAbsolute(raw) ? raw : resolve(worktreePath, raw);
  return fs.realpath(abs);
}

/**
 * Re-audit 06g N7: realpath of the source checkout (the MAIN worktree of the
 * repo the mission worktree was added to) — `git worktree list --porcelain`
 * lists it first. Needed to deny its `.env` files by absolute path.
 */
export async function resolveSourceRepoRoot(
  worktreePath: string,
  runner: GitRunner = defaultRunner,
): Promise<string> {
  const res = await runner(["worktree", "list", "--porcelain"], worktreePath);
  const first = res.stdout.split("\n").find((line) => line.startsWith("worktree "));
  if (res.status !== 0 || first === undefined) {
    throw new Error(
      `source-git-dir-resolver: git worktree list --porcelain thất bại trong ${worktreePath}: ${res.stderr.trim()}`,
    );
  }
  return fs.realpath(first.slice("worktree ".length).trim());
}
